import { takeLatest, call, put } from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { getOrderDetails, applyAdjustment } from 'yoda-interfaces/lib/Order/OrderApi';
import { getCouponListAurora } from 'yoda-interfaces/lib/Coupon/CouponApi';
import FactorySaga from './FactorySaga';
import {
    ACTIVECART_DRAFTORDER_GET_REQUEST,
    ACTIVECART_DRAFTORDER_GET_SUCCESS,
    ACTIVECART_DRAFTORDER_GET_ERROR,
    ACTIVECART_BESTCOUPON_GET_REQUEST,
    ACTIVECART_BESTCOUPON_GET_SUCCESS,
    ACTIVECART_BESTCOUPON_GET_ERROR,
    ACTIVECART_APPLY_BESTCOUPON_POST_REQUEST,
} from '../actionTypes/ActiveCartReminderActionTypes';
import analyticsActions from '../actions/AnalyticsAction';
import {
    GENERIC_API_ERROR,
    GENERIC_API_ERROR_MESSAGE,
    couponErrorMessages,
    CART_PAGE_URL,
} from '../common/Constants';

function* ActiveCartDraftOrderSaga(action) {
    try {
        if (!action.payload) {
            action.payload = {};
        }
        action.payload.origin = 'cart';
        action.payload.expand = 'billing';
        const cartDetails = yield call(FactorySaga, getOrderDetails, action);
        if (cartDetails.isSuccess) {
            const { response } = cartDetails;
            const responseData = response.data;
            yield put({
                type: ACTIVECART_DRAFTORDER_GET_SUCCESS,
                cartDraftOrderDetails: responseData,
            });
            if (!isEmpty(responseData) && isEmpty(responseData.adjustments)) {
                yield put({ type: ACTIVECART_BESTCOUPON_GET_REQUEST });
            }
        } else {
            const error = {
                errorCode: GENERIC_API_ERROR,
                errorMessage: GENERIC_API_ERROR_MESSAGE,
            };
            yield put({ type: ACTIVECART_DRAFTORDER_GET_ERROR, error });
        }
    } catch (error) {
        yield put({ type: ACTIVECART_DRAFTORDER_GET_ERROR, error });
    }
}

export const watchActiveCartDraftOrderSaga = function* watchActiveCartDraftOrderSaga() {
    yield takeLatest(ACTIVECART_DRAFTORDER_GET_REQUEST, ActiveCartDraftOrderSaga);
};

watchActiveCartDraftOrderSaga.sagaName = 'watchActiveCartDraftOrderSaga';

function* ActiveCartBestCouponSaga() {
    try {
        let coupons = {};
        const params = {
            payload: {
                priceFlag: true,
                marketing: null,
                unmerged: false,
            },
        };
        const result = yield call(FactorySaga, getCouponListAurora, params);
        coupons = get(result, 'response.data', {});
        coupons.status = get(result, 'response.status');

        yield put({
            type: ACTIVECART_BESTCOUPON_GET_SUCCESS,
            coupons,
        });
    } catch (error) {
        yield put({
            type: ACTIVECART_BESTCOUPON_GET_ERROR,
            error,
        });
    }
}

export const watchActiveCartBestCouponSaga = function* watchActiveCartBestCouponSaga() {
    yield takeLatest(ACTIVECART_BESTCOUPON_GET_REQUEST, ActiveCartBestCouponSaga);
};

watchActiveCartBestCouponSaga.sagaName = 'watchActiveCartBestCouponSaga';

function* ApplyBestCouponOnActiveCartSaga(action) {
    let adjustmentResponse;
    try {
        adjustmentResponse = yield call(FactorySaga, applyAdjustment, action);
        if (!isEmpty(adjustmentResponse)) {
            window.location.pathname = CART_PAGE_URL;
        }
    } catch (error) {
        const errorCode = get(adjustmentResponse, 'response.data[0].errorCode');
        const errorMessage =
            couponErrorMessages[errorCode] ||
            get(adjustmentResponse, 'response.data[0].errorMessage') ||
            couponErrorMessages.COUPON_REQUEST_ERROR;

        yield put(
            analyticsActions.triggerFormError([
                { errorDescription: `Active Cart Reminder |${errorMessage}` },
            ])
        );
    }
}

export const watchApplyBestCouponOnActiveCartSaga = function* watchApplyBestCouponOnActiveCartSaga() {
    yield takeLatest(ACTIVECART_APPLY_BESTCOUPON_POST_REQUEST, ApplyBestCouponOnActiveCartSaga);
};

watchApplyBestCouponOnActiveCartSaga.sagaName = 'watchApplyBestCouponOnActiveCartSaga';
